const TYPES = {
  ParkingStore: Symbol.for('ParkingStore'),
  APIService: Symbol.for('APIService'),
  AnalyticService: Symbol.for('AnalyticService'),
  AnalyticService_CONFIG_GA_ID : Symbol.for('ga.trackingId'),
  RemoteAPI : Symbol.for('remoteAPI')
};

export { TYPES };
